import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseUrl } from 'src/app/framework/constants/url-constants';

@Injectable({
    providedIn: 'root'
})
export class ConsentService {

    constructor(
        private readonly http: HttpClient,
    ) { }

    updatePatientConsents(payload) {
        const href = `${BaseUrl.PATIENT}/patient-consent`;
        return this.http.put(href, payload);
    }

    hasOptionalConsent(id) {
        const href = `${BaseUrl.PATIENT}/patient-consent/${id}/is-optional-consent`;
        return this.http.get<any>(href);
    }

}
